import { create } from "zustand";
import type { Worktree } from "@rivets/core";

interface ArchiveToastState {
  worktree?: Worktree;
  show: (worktree: Worktree) => void;
  dismiss: () => void;
}

let dismissTimer: ReturnType<typeof setTimeout> | undefined;

export const useArchiveToast = create<ArchiveToastState>((set) => ({
  show: (worktree) => {
    if (dismissTimer) clearTimeout(dismissTimer);
    set({ worktree });
    dismissTimer = setTimeout(() => set({ worktree: undefined }), 8_000);
  },
  dismiss: () => {
    if (dismissTimer) clearTimeout(dismissTimer);
    dismissTimer = undefined;
    set({ worktree: undefined });
  },
}));
